import { Box, CircularProgress } from "@material-ui/core";

const TopMenu = ({ menu, classes, parseTitle, loading }) => (
  <Box className={classes.topMenu}>
    {loading && !menu && (
      <CircularProgress
        color="secondary"
        className={classes.circularProgress}
      />
    )}
    {menu &&
      menu.map((item, index) => (
        <a key={index} href={item.url} className={classes.topMenuItem}>
          {parseTitle(item.title)}
        </a>
      ))}
  </Box>
);

export default TopMenu;
